import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { getCookie, setCookie } from '@apps/tools';

@Injectable()
export class CheckCIDGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const cid = route.queryParams.cid;
    if (cid) {
      if (!getCookie('cid') && /^[a-z0-9_\-]+$/.test(cid)) {
        setCookie('cid', cid, 90);
      }

      let url = state.url
        .replace(`?cid=${ cid }`, '')
        .replace(`&cid=${ cid }`, '');

      if (url.indexOf('?') === -1 && url.indexOf('&') !== -1) {
        url = url.replace('&', '?')
      }

      this.router.navigateByUrl(url);
      return false;
    }

    return true;
  }
}
